var $class="se2--container-tab--item",$name="ContainerTab/item",$path="app/components/ContainerTab/partials/item/index.js",$this={$class,$name,$path,};const itemClassName = `${$class}`;

export default itemClassName;
